import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form } from 'informed';
import { fetchAvaiableTransferProcess } from '../../../services/options_service';
import { FieldSet, InputBirth, InputCell, InputCpf, InputTypeDropdown, InputTypeText, KeyValue, Spinner } from '../../../elements';
import { API_URL } from '../../../../lib/const';
import Axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { TTransferApplicationStepPageProps } from '../types';
import { IFormApi } from '../../types';
import ApplicationProcessFinderModal from '../components/ApplicationProcessFinderModal';
import AutosaveFeedback from '../../../components/autoSaveFeedBack';
import TransferApplicationGradeInput from '../components/TransferApplicationGradeInput';
import consts from '../consts';
import formater from '../../common/formater';
import { updateAndFetchTransferApplication } from '../services/transferApplicationService';


const TransferApplicationFormPage = ({ history, match, location, application, setApplication }: TTransferApplicationStepPageProps) => {
  let previousErrors: any = {};

  const [loading, setLoading] = useState(true);
  const [processes, setTrasferProcesses] = useState([]);
  const [predefinedProcess, setPredefinedProcess] = useState<number>();
  const [CPFChecked, setCPFChecked] = useState('idle');
  const token = useMemo(() => match.params.token, [match.params.token]);
  const edit = !!token;
  const convoked = edit && application.process.kind === consts.TransferProcessKind.CONVOCATION;

  useEffect(() => {
    fetchAvaiableTransferProcess()
      .then(setTrasferProcesses)
      .finally(() => setLoading(false))

  }, [])

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get('processo') !== null) {
      setPredefinedProcess(+(params.get('processo') as string))
    }

  }, [location])

  const handleCreateTransferApplication = useCallback(async (formApi: IFormApi) => {
    setLoading(true);

    const payload = {
      ...formApi.getState().values,
    }

    try {
      if (edit) {
        const updatedApplication = await updateAndFetchTransferApplication(token, payload);
        setApplication(() => updatedApplication);

        history.push(`/transferencias/aplicacao/${token}/documentos`)

      } else {
        const response = await Axios.post(`${API_URL}/transfers/applications`, payload);

        history.push(`/transferencias/aplicacao/${response.data.token}/documentos`)
      }

    } catch (error) {
      const response = (error as AxiosError).response;

      if (response && response.status === 400) {
        const errors = response.data;

        Object.keys(previousErrors).forEach((fieldName) => {
          if (formApi.fieldExists(fieldName)) {
            formApi.setError(fieldName, null);
          }
        });

        previousErrors = { ...errors };

        Object.entries(errors).forEach((e) => {
          if (formApi.fieldExists(e[0])) {
            formApi.setError(e[0], e[1] as string[]);
          }
        });

        if (errors.non_field_errors) {
          toast.error(errors.non_field_errors.join(','))

        } else {
          toast.error('Ocorreu um erro ao registrar sua inscrição.')
        }

      } else {
        toast.error('Ocorreu um erro desconhecido registrar sua inscrição.')

      }

    } finally {
      setLoading(false);

    }
  }, [token]);

  return (
    <Form
      key={edit ? application.id : predefinedProcess}
      initialValues={edit ? {
        ...application,
        process: application.process.id,
        desired_onboarding: application.desired_onboarding.id,
      } : { process: predefinedProcess }}
    >
      {({ formApi, formState }: { formApi: IFormApi, formState: { values: { cpf?: string, process?: number } } }) => (
        <>
          <Spinner active={loading}>
            <FieldSet>
              {convoked ? (
                <>
                  <KeyValue col="6" title={application.process.name} label="Processo" />
                  <KeyValue col="6" title={`${application.desired_onboarding.field_step}ᵒ`} label="Período pleiteado" />
                  <KeyValue col="6" title={formater.cpf(application.cpf)} label="CPF" />
                </>
              ) : (
                <>
                  <InputTypeDropdown
                    col="6"
                    field="process"
                    label="Processo"
                    placeholder="Escolha qual processo deseja candidatar"
                    options={processes}
                    disabled={application.status === 'Com pendências'}
                    required
                  />
                  <TransferApplicationGradeInput
                    col="6"
                    field="desired_onboarding"
                    processId={formState.values.process}
                    label="Período pleiteado"
                    disabled={application.status === 'Com pendências'}
                  />
                  <InputCpf
                    field="cpf"
                    label="CPF"
                    col="6"
                    helper="Ex: 000.000.000-00"
                    required
                    disabled={application.status === 'Com pendências'}
                    autosaveFeedBack={(!edit) && (
                      <AutosaveFeedback
                        status={(() => {
                          const unmakedCPF = (formState.values.cpf || '').replace(/\D/g, "");

                          if (unmakedCPF.length === 11 && application && CPFChecked === 'idle') {
                            return 'saving';

                          } else if (CPFChecked === 'error') {
                            return 'error';

                          } else if (['found', 'not found'].includes(CPFChecked)) {
                            return 'ok';

                          }
                          return 'none';

                        })()}
                      />
                    )
                    }
                  />
                </>
              )}
              {(edit || CPFChecked === 'not found') && (
                <>
                  <InputTypeText
                    field="real_name"
                    label="Nome"
                    col="6"
                    required
                  />
                  <InputTypeText
                    field="assumed_name"
                    label="Nome Social"
                    col="6"
                  />
                  <InputCell
                    field="phone"
                    label="Telefone"
                    col="6"
                    helper="Ex: (31) 99999999"
                    required
                  />
                  <InputTypeText
                    field="email"
                    label="Email"
                    col="6"
                    required
                  />
                  <InputBirth
                    field="birth_date"
                    label="Data de Nascimento"
                    col="6"
                    helper="Ex: 18/12/2001 - (Mes/Dia/Ano)"
                    required
                  />
                </>
              )}
            </FieldSet>
            {!edit && (
              <ApplicationProcessFinderModal
                cpf={formState.values.cpf}
                process={formState.values.process}
                onCompleteFind={(result, application) => {
                  setCPFChecked(result);
                  formApi.setError('cpf', null);

                  if (result === 'found' && application) {
                    setTimeout(() => history.push(`/transferencias/aplicacao/${application.token}`), 3 * 1000);

                  }

                  if (result === 'error') {
                    formApi.setError('cpf', ['CPF inválido']);

                  }
                }}
              />
            )}
          </Spinner>
          <div className="text-right">
            <div className="col-md-4 p-0 offset-md-8 col-sm-12">
              <div className="btn-actions">
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={loading || (!edit && CPFChecked === 'idle')}
                  onClick={() => handleCreateTransferApplication(formApi)}
                >
                  {loading ? "Carregando..." : "Próximo"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Form>
  );
};

export default TransferApplicationFormPage;
